/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA1Icon16Regular = forwardRef('DataChartPieA1Icon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a.75.75 0 0 0-.75.75V8a.75.75 0 0 0 1.125.65l5.413-3.125a.75.75 0 0 0 .274-1.025A7 7 0 0 0 8 1Zm.75 5.701v-4.15a5.5 5.5 0 0 1 3.594 2.075L8.75 6.701Z" }),
        React.createElement("path", { d: "M5.586 3.058a.75.75 0 0 0-.658-1.348 7 7 0 1 0 10.067 6.026.75.75 0 1 0-1.499.057 5.501 5.501 0 1 1-7.91-4.735Z" })));
});
